import React, { Fragment } from 'react';
import { Button }from '@cmsgov/design-system';

import { FormattedMessage } from 'react-intl';

// Components

import ModalHeader from '@common-components/headers/ModalHeader';




const InformLawfullyPresenceRequiredForCoverageModal = props => {

    const {
        actions: {
            hideAllModals
        },
        bottomAnchors: [
            anchor_1,
        ],
        environment: {
            exchangeName
        },
        boundAnchor,
        modal: {
            modalData: {
                callbacks
            }
        },
        modalHeaderProps,
        modalHeaderProps: {
            modalId
        }
    } = props;

    const handleHideClick = () => hideAllModals();

    const handleRightBtnClick = () => {
        callbacks.map(callback => {
            callback();
        });
        handleHideClick();
    };

    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader
                    {...{
                        ...modalHeaderProps,
                        hideModal: hideAllModals
                    }}
                    closeAllModals
                    hideAllModals={hideAllModals}
                />
            </div>
            <div className="gi-modal__body txt-left" id = 'informLawfullyPresenceRequiredForCoverageModal' >
                <span data-testid={`${modalId}-notice`}>
                    <FormattedMessage
                        id='modals.lawful_presence.notice'
                        tagName='p'
                        values={{
                            exchangeName,
                            br: <br />,
                        }}
                    />
                </span>
            </div>
            <div className='gi-modal__controls'>
                <Button
                    className='usa-button usa-button--outline gi-button gi-button__outline'
                    data-testid={`${modalId}-close_btn`}
                    onClick={handleHideClick}
                >
                    <FormattedMessage id='button.close'/>
                </Button>
                <Button
                    className='usa-button gi-button gi-button__primary'
                    data-testid={`${modalId}-ok_btn`}
                    onClick={handleRightBtnClick}
                    inputRef={boundAnchor(anchor_1)}
                >
                    <FormattedMessage id='button.ok'/>
                </Button>
            </div>
        </Fragment>
    );
};

export default InformLawfullyPresenceRequiredForCoverageModal;
